export const USER_TYPES = {
  ADD_EMAIL_FOR_STRIPE: 'ADD_EMAIL_FOR_STRIPE',
  RESET_STATE: 'RESET_STATE',
  ADD_USER: 'ADD_USER'
}


